import $ from 'jquery';

$(() => {
    $('#deleteSitesModalOK').on('click', () => {
        $('input[name=removeAllSites]').prop('disabled', false).val('true').closest('form').submit()
    });
});
